import { Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQ from "./pages/Faq";
import Pricing from "./pages/Pricing";
import Services from "./pages/Services";
import Products from "./pages/Products";
import Nemt from "./pages/Nemt";
import PdfViewer from "./pages/PdfViewer";
import { StyleSheet } from "@react-pdf/renderer";
import "./App.css";


function App() {
       const styles = StyleSheet.create({
         page: {
          flexDirection: "row",
          backgroundColor: "#61dafb",
        }
       }); 
  const navigate = useNavigate();

  const handleHome = () => {
    console.log("Home button clicked");
    navigate("/");
  };
  const handleAbout = () => {
    console.log("About button clicked");
    navigate("/about");
  };
  
  const handleContact = () => {
    console.log("Contact button clicked");
    navigate("/contact");
  };
  const handleFAQ = () => {
    console.log("FAQ button clicked");
    navigate("/faq");
  };
  const handlePricing = () => {
    console.log("Pricing button clicked");
    navigate("/pricing");
  };
  const handleServices = () => {
    console.log("Services button clicked");
    navigate("/services");
  };
  const handleProducts = () => {
    console.log("Products button clicked");
    navigate("/products");
  };


  return (
    <div className="App">
      <header className="App-header">
        <h1>Welcome to ISW website</h1>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={handleHome}>Home</button>
          <button onClick={handleAbout}>About</button>
          <button onClick={handleContact}>Contact</button>
          <button onClick={handleFAQ}>FAQ</button>
          { /* <button onClick={handlePricing}>Pricing</button> */ }
          <button onClick={handleServices}>Services</button>
          <button onClick={handleProducts}>Products</button> 
        </div>
      </header>
      <br />
      <div className="App-content"></div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/nemt" element={<Nemt />} />
        <Route path="/products/nemt/pdf" element={<PdfViewer />} />
      </Routes>
      <footer style={styles.page} className="App-footer">
        <table><tbody><tr width="100%">
          <td align="left">© 2025 Internet Software Works</td>
          <td align="right">Created by Tom Erickson of <a href="internetsoftwareworks.com">Internet Software Works</a></td>
        </tr>
        </tbody></table>
      </footer>
    </div>
  );
}

export default App;
